import { type FC } from 'react'

import { type OpenableControls } from '../../../../generic-hooks'
import { useDirectContactFormFormStateInitialization } from '../../../hooks/useDirectContactFormFormStateInitialization'

import { DirectContactFormOrderTypeForm } from './DirectContactFormOrderTypeForm'

export const DirectContactFormReturnItem: FC<{
  onFormSubmittedWithSuccess: () => void
  userModalControls: OpenableControls
}> = ({ onFormSubmittedWithSuccess, userModalControls }) => {
  const formState = useDirectContactFormFormStateInitialization()
  formState.use()

  return (
    <DirectContactFormOrderTypeForm
      formState={formState}
      onFormSubmittedWithSuccess={onFormSubmittedWithSuccess}
      userModalControls={userModalControls}
    />
  )
}
